import React from "react";

interface CheckboxProps extends React.HTMLAttributes<HTMLInputElement>{
  checked?: boolean | undefined
  value?: string
}

class Checkbox extends React.Component<CheckboxProps> {
  
  render() {
    return (     
      <input
        {...this.props}
        type="checkbox"  
        style={{
          width:"18px",
          height:"18px",
        }}        
      />
    );
  }
}

export default Checkbox;